import { useCallback } from "react";
import CategorizedNomenclatureListPage from "../../../common/nomenclatures/CategorizedNomenclatureListPage";
import { endpointsMetadata } from "../../../common/infrastructure/routes/endpointsMetadata";
import {
  serviceTypeSchema,
  IServiceTypeInputModel,
  getServiceTypeDefaults,
} from "./models/serviceTypeInputModel";
import { ServiceTypeListItem } from "./components/ServiceTypeListItem";
import { ServiceTypeFormFields } from "./components/ServiceTypeFormFields";
import { ISelectFieldModel } from "../../../common/components/forms/inputs/dropdown/models/selectFieldModel";
import { useApiQuery } from "../../../common/infrastructure/hooks/useApiQuery";
import {
  IServiceTypeAdditionalDataViewModel,
  IServiceTypeCategoryModel,
} from "./models/serviceTypeAdditionalDataViewModel";
import { ICategorizedNomenclatureEndpoints } from "../../../common/nomenclatures/models/categorizedNomenclatureEndpoints";

export const ServiceTypesNomenclature = () => {
  const { data: availableEmployees } = useApiQuery<ISelectFieldModel[]>({
    queryKey: [endpointsMetadata.statistics.getAllEmployees],
    endpoint: endpointsMetadata.statistics.getAllEmployees,
    globalIsLoading: false,
  });

  const { data: additionalData } =
    useApiQuery<IServiceTypeAdditionalDataViewModel>({
      queryKey: [
        endpointsMetadata.serviceTypeNomenclature.getNomenclatureAdditionalData,
      ],
      endpoint:
        endpointsMetadata.serviceTypeNomenclature.getNomenclatureAdditionalData,
      globalIsLoading: false,
    });

  const endpoints =
    endpointsMetadata.serviceTypeNomenclature as ICategorizedNomenclatureEndpoints;

  // Transform form data to API payload (strip frontend-only fields)
  const transformPayload = useCallback(
    (data: IServiceTypeInputModel): Partial<IServiceTypeInputModel> => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { isPriceRange, ...apiPayload } = data;
      return apiPayload;
    },
    []
  );

  return (
    <CategorizedNomenclatureListPage<
      IServiceTypeInputModel,
      IServiceTypeInputModel,
      IServiceTypeCategoryModel
    >
      endpoints={endpoints}
      title="Типове услуги"
      description="Клиентите виждат услугите в този ред. Ако всички услуги са без категория, клиентите виждат директно списък с услуги."
      dialogAddTitle="Добавяне на нов тип услуга"
      dialogEditTitle="Редактиране на тип услуга"
      emptyListText="В момента нямате добавени типове услуги"
      editOnRowClick
      itemTemplate={(item, index, isLoading, actionButtons, className) => (
        <ServiceTypeListItem
          item={item}
          isLoading={isLoading}
          actionButtons={actionButtons}
          className={className}
        />
      )}
      formSchema={serviceTypeSchema}
      defaultValues={() => getServiceTypeDefaults()}
      formFields={
        <ServiceTypeFormFields
          availableEmployees={availableEmployees}
          additionalData={additionalData}
        />
      }
      transformPayload={transformPayload}
      enableSearch
    />
  );
};
